import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/seo/Seo';

const NotFoundPage = () => (
    <>
        <Seo
            title="Page not found (404)"
            description="The page you requested could not be found on pdfconvertor.shop."
            path="/"
            noindex
        />

        <div className="page-container narrow">
            <section className="content-section" style={{ textAlign: 'center' }}>
                <h1 style={{ fontSize: '4rem', margin: '2rem 0 0.5rem' }}>404</h1>
                <h2>We couldn&apos;t find that page.</h2>
                <p>
                    The link may have moved, or you may have typed the address wrong.
                    Here are some good places to go instead:
                </p>
                <ul style={{ listStyle: 'none', padding: 0, lineHeight: 2 }}>
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/word-to-pdf">Word to PDF</Link></li>
                    <li><Link to="/image-to-pdf">Image to PDF</Link></li>
                    <li><Link to="/compress-pdf">Compress PDF</Link></li>
                    <li><Link to="/blog">Blog</Link></li>
                    <li><Link to="/contact">Contact</Link></li>
                </ul>
            </section>
        </div>
    </>
);

export default NotFoundPage;
